<script>
import {
  required, requiredIf
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'CreateModal',
  props:[
      "routerList",
      "routerId"
  ],
  data() {
    return {
      portName: [],
      balanceName: [],
      form: { 
        type: 'dsl',
        router_id:null
      },
      submitted: false,
    };
  },
  validations: {
    form: {
      balance_name: {
          required: requiredIf(function () {
              if(this.form.type == 'dsl') {
                  return true; 
              } 
               return false
          })
      },
      name: {
          required: requiredIf(function () {
              if(this.form.type == 'dsl') {
                  return true; 
              } 
                return false
          })
      },
      router_id: { 
        required: requiredIf(function () {
            if(this.routerId) {
                return true; 
            } 
              return false
        })
      },
      type: { required },
      ip: { required },
      start: { required },
      end: { required },
      interval: { required },
    },
  },
  watch:{
    routerId(props){
      this.form.router_id = props
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
    
      if (this.$v.$invalid) {
        return;
      } else {

        if(this.form.id)
          this.update();
          else
          this.create();

          this.$emit('loadItems');
      }
      this.submitted = false;

    },
    create(){
     
      this.$http.post('/ports/store', this.form)
        .then(resp => {
          this.form = {};
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    update(){
      this.$http.put('/ports/' + this.form.id , this.form)
        .then(resp => {
          this.form = {};
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    remove(id){
      this.$http.delete('/ports/' + id)
        .then(resp => {
          if(resp.data.code !==  100)  return notify.error(resp.data.message)
           return notify.success(resp.data.message)
         })
        .catch(error => error)
    },
    close(){
      this.$parent.$bvModal.hide('modal-hat')
    },
    getInterface(prop){
        this.$http.post('/ports/getInterface',{ routerId:prop.id })
        .then(resp => {
            if(resp.data.code ==  101)  return notify.error(resp.data.message)

            this.getBalanceName(prop)
            this.portName = resp.data
         })
        .catch(error => error)
    },
    getBalanceName(){
        this.$http.post('/ports/getBalanceName',{ routerId: this.form.router_id })
        .then(resp => {
          //if(resp.data.code !==  100)  return notify.error(resp.data.message)

            this.balanceName = resp.data
         })
        .catch(error => error)
    },
    getAdresListByInterface(prop){
       this.$http.post('/ports/getAdresListByInterface',{ name:prop, routerId:this.form.router_id })
        .then(resp => {
            if(resp.data.code ==  101)  return notify.error(resp.data.message)
          
            this.form= Object.assign({ ip:resp.data.address },this.form); 
         })
        .catch(error => error)
  
    }
  },
};
</script>

<template>
  <b-modal id="modal-hat" title="Hat/Port Ekle"  no-close-on-backdrop hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="type">Hat Türü</label>
              <select v-model="form.type" class="form-select">
                <option value="">Seçiniz</option>
                <option value="dsl">DSL</option>
                <option value="metro">Metro</option>
              </select>
              <div
                v-if="submitted && !$v.form.type.required"
                class="invalid-feedback"
              >
                Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12" v-if="!routerId">
            <div class="mb-3">
              <label for="router_id">Router</label>
              <v-select 
                v-model="form.router_id"
                :options="routerList"
                @option:selecting="getInterface($event)"
                label="nasname"
                :reduce="r => r.id">
                  <template slot="no-options">
                    Router ismi veya ip ile arayın
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                     {{ option.nasname }} - {{ option.shortname }}
                      </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.nasname }} - {{ option.shortname }}
                    </div>
                  </template>
              <span slot="no-options">Sonuç Bulunamadı</span>
              </v-select>
              <div
                v-if="submitted && !$v.form.router_id.required"
                class="invalid-feedback"
              >
                Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12"  v-if="form.type == 'dsl'">
            <div class="mb-3">
              <label for="name">Hat Adı</label>
              <v-select 
                v-model="form.name"
                :options="portName"
                @option:selecting="getAdresListByInterface($event)">
              <span slot="no-options">Sonuç Bulunamadı</span>
              </v-select>
              <div
                v-if="submitted && !$v.form.name.required"
                class="invalid-feedback"
              >
                Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12" v-if="form.type == 'dsl'">
            <div class="mb-3">
              <label for="balance_name">Balans Adı</label>
              <v-select 
                v-model="form.balance_name"
                :options="balanceName"
                label="balance_name">
              <span slot="no-options">Sonuç Bulunamadı</span>
              </v-select>
              <div
                v-if="submitted && !$v.form.balance_name.required"
                class="invalid-feedback"
              >
                Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
           <div class="col-12">
            <div class="mb-3">
              <label for="ip">İp</label>
              <input
                    id="ip"
                    v-model="form.ip"
                    type="text"
                    class="form-control"
                    placeholder="192.1.1.1"
                    :class="{
                      'is-invalid': submitted && $v.form.ip.$error,
                    }"
                  />
              <div
                v-if="submitted && !$v.form.ip.required"
                class="invalid-feedback"
              >
                Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row mb-3">
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="start">Port Başlangıç</label>
                  <input
                    id="designation"
                    v-model="form.start"
                    type="text"
                    class="form-control"
                    placeholder="10000"
                    :class="{
                      'is-invalid': submitted && $v.form.start.$error,
                    }"
                  />
                  <div
                    v-if="submitted && !$v.form.start.required"
                    class="invalid-feedback"
                  >
                  Bu alanı doldurmak zorunludur.
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="end">Port Bitis</label>
                  <input
                    id="end"
                    v-model="form.end"
                    type="text"
                    class="form-control"
                    placeholder="65535"
                    :class="{
                      'is-invalid': submitted && $v.form.end.$error,
                    }"
                  />
                  <div
                    v-if="submitted && !$v.form.end.required"
                    class="invalid-feedback"
                  >
                  Bu alanı doldurmak zorunludur.
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="name">Port Aralık</label>
                  <input
                    id="interval"
                    v-model="form.interval"
                    type="text"
                    class="form-control"
                    placeholder="1000"
                    :class="{
                      'is-invalid': submitted && $v.form.interval.$error,
                    }"
                  />
                  <div
                    v-if="submitted && !$v.form.interval.required"
                    class="invalid-feedback"
                  >
                  Bu alanı doldurmak zorunludur.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>